/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Translate_Need_TargetsInputs */

const cs_property_ai_translate_need_targets = /** @type {(inputs: Property_Ai_Translate_Need_TargetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte alespoň jeden cílový jazyk`)
};

const en_property_ai_translate_need_targets = /** @type {(inputs: Property_Ai_Translate_Need_TargetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select at least one target language`)
};

/**
* | output |
* | --- |
* | "Select at least one target language" |
*
* @param {Property_Ai_Translate_Need_TargetsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_translate_need_targets = /** @type {((inputs?: Property_Ai_Translate_Need_TargetsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Translate_Need_TargetsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_translate_need_targets(inputs)
	return cs_property_ai_translate_need_targets(inputs)
});